import styled from "@emotion/styled";
import { Col, Row } from "antd";

export const RootContainer = styled(Row)`
  background-color: ${(props) => props.theme.color.secondary};
  overflow-x: scroll;
  min-width: 768px;

  @media (min-width: 768px) {
    width: 100%;
  }
`;

export const MainMenuBar = styled(Col)`
  background-color: ${(props) => props.theme.color.primary};
  min-height: 100vh;
  z-index: 1;
`;

export const ContentContainer = styled.div`
  background-color: ${(props) => props.theme.color.white};
  min-height: 100vh;
  padding: 40px;

  @media (min-width: 1200px) {
    margin: 0 auto;
    width: 100%;
    padding: 40px;
    box-shadow: 0px 3px 8px #e0e0e0;
  }
`;
